import { getActivePinia } from "pinia";

import type { Pinia, PiniaPluginContext, StoreGeneric } from "pinia";

export type StoreScope = "global" | "case";

const registry = new WeakMap<Pinia, Map<StoreScope, Set<StoreGeneric>>>();

export function scopePlugin({ pinia, store, options }: PiniaPluginContext) {
  let scopes = registry.get(pinia);
  if (scopes == null) registry.set(pinia, (scopes = new Map<StoreScope, Set<StoreGeneric>>()));

  let stores = scopes.get(options.scope);
  if (stores == null) scopes.set(options.scope, (stores = new Set()));

  stores.add(store);
}

export function resetScopedStores(scope: StoreScope, pinia: Pinia | undefined = getActivePinia()) {
  if (pinia == null) return;

  for (const store of registry.get(pinia)?.get(scope) ?? []) {
    if (typeof store.reset === "function") (store.reset as () => void)();
    else store.$reset();
  }
}

declare module "pinia" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface DefineStoreOptionsBase<S, Store> {
    readonly scope: StoreScope;
  }
}
